import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import { environments } from '../utils/environments';

export const firebaseApp = firebase.initializeApp(environments.firebaseConfig);
